import type { Reply } from "../client/http.ts";
import { designCopy } from "../design/copy.ts";
import { agencyCopy } from "./copy.ts";

export function replyProblem(reply: Exclude<Reply<unknown>, { readonly kind: "feito" }>, taking = false): string {
  if (reply.kind === "pendente") return agencyCopy.equipe.semResposta;
  const { error } = reply;
  if (error.kind === "rede") return designCopy.semConexao;
  if (error.kind === "formato") return designCopy.erros.interno;
  return taking && error.code === "ocupado" ? agencyCopy.equipe.semLeitura : error.message;
}
